import { Outlet, useLocation, useNavigate } from "react-router-dom";
import Header from "./header/Header";
import React, { Suspense, useEffect, useMemo, useState } from "react";
import NotFountError from "../notfounterror/NotFountError";
import { useSelector } from "react-redux";
import { ClientConfigOverride } from "../../config/careers/clientConfig";

const OnBoardingRoot = () => {
    const teamConfig = useSelector((state: any) => { return state?.newRole?.teamConfig; });
    const clientSettings = useMemo(() => {
        const raw = teamConfig?.data?.clientSettings?.clientSiteSettings;
        return raw ? JSON.parse(raw) : raw;
    }, [teamConfig]);

    const location = useLocation();
    const navigate = useNavigate();
    const [pageNotLoad, setPageNotLoad] = useState<boolean>(false);
    useEffect(() => {
        if (location.pathname === "/getCandidate" || location.pathname === "/getCandidate/") {
            // navigate("*");
            setPageNotLoad(true);
        } else {
            setPageNotLoad(false);
        }
        
    }, [location]);

    
    const shouldRenderCustomHeader = clientSettings?.complianceHeader;
    const shouldRenderCustomFooter = clientSettings?.complianceFooter;
    const templateFolder = clientSettings?.complianceTemplateFolderName;

    /* To render header/footer from careers folder */
    const useCareerHeaderFooter = clientSettings?.useCareerHeaderFooter === true;

    const careerClientConfig = useMemo(() => {
        if (!useCareerHeaderFooter) {
            return null;
        }
        return {
            data: {
                data: {
                    clientSettings: {
                        ...teamConfig?.data?.clientSettings,
                        clientSiteSettings: clientSettings,
                    },
                },
            },
        };
    }, [useCareerHeaderFooter, teamConfig, clientSettings]);

    // Dynamically load CSS if header OR footer flag is true
    useEffect(() => {
        if ((shouldRenderCustomHeader || shouldRenderCustomFooter) && templateFolder) {
            if (useCareerHeaderFooter) {
                const cssFiles: string[] = clientSettings?.clientCssFiles || [];
                cssFiles.forEach((cssFile: string) => {
                    import(`../careers/header/clientsMenu/${templateFolder}/css/${cssFile}`)
                        .catch((err) => {
                            console.warn("Failed to load careers CSS:", cssFile, err);
                        });
                });
            } else {
                import(`./customHeaders/${templateFolder}/css/main.scss`)
                    .then(() => {
                        console.log("Custom CSS loaded successfully");
                    })
                    .catch((err) => {
                        console.warn("Failed to load custom CSS:", err);
                    });
            }
        }
    }, [shouldRenderCustomHeader, shouldRenderCustomFooter, templateFolder, useCareerHeaderFooter, clientSettings]);

    useEffect(() => {
        if (!useCareerHeaderFooter || teamConfig?.statusCode !== 200) {
            return;
        }

        const settings = teamConfig?.data?.clientSettings;
        const root = document.documentElement;

        document.title = `${settings?.titleTabText} - Compliance`;
        root.style.setProperty("--primary-color", settings?.brandColor);
        root.style.setProperty("--theam-secondary-color", settings?.secondaryColor);

        // CareersHeader also applies these for careers components that theme off them.
        Object.entries(clientSettings?.customCareerThemeColors || {}).forEach(([key, value]) => {
            root.style.setProperty(`--${key}`, `${value}`);
        });

        let link: any = document.querySelector("link[rel~='icon']");
        if (!link) {
            link = document.createElement("link");
            link.rel = "icon";
            document.getElementsByTagName("head")[0].appendChild(link);
        }
        link.href = settings?.favIcon;
    }, [useCareerHeaderFooter, teamConfig, clientSettings]);

    const renderCustomMenu = (templateName: string, folderName: string, isFooter?: boolean) => {
        if (templateName !== "") {
            const load = () => {
                if (useCareerHeaderFooter) {
                    // Careers footers live flat in customFooterTemplates - no folder.
                    return isFooter
                        ? import(`../careers/CareersFooter/customFooterTemplates/${templateName}`)
                        : import(`../careers/header/clientsMenu/${folderName}/${templateName}`);
                }
                return import(`./customHeaders/${folderName}/${templateName}`);
            };

            return <ClientConfigOverride.Provider value={careerClientConfig}>
                <Suspense fallback={<></>}>
                    {React.createElement(React.lazy(() => load().catch(() => ({ default: () => <div>Not loading....</div> }))), { teamConfig })}
                </Suspense>
            </ClientConfigOverride.Provider>;
        }
        return null;
    };

    return (
        <>
            {shouldRenderCustomHeader ? (
                <div className="custom-onboarding-header custom-compliance-div">
                    {renderCustomMenu(clientSettings?.complianceHeaderTeamplateName, clientSettings?.complianceTemplateFolderName)}
                </div>
            ) : (
                <Header />
            )}

            <div>
                {pageNotLoad ? <NotFountError /> : <Outlet />}
            </div>

            {shouldRenderCustomFooter && (
                <div className="custom-onboarding-footer custom-compliance-div">
                    {renderCustomMenu(clientSettings?.complianceFooterTeamplateName, clientSettings?.complianceTemplateFolderName, true)}
                </div>
            )}
        </>
    );
};

export default OnBoardingRoot;